export default __webpack_public_path__ + "img/f08435525fb77a72e18ac7d0d0414d68.png";